// returns a new object with the values at each key mapped using mapFn(value)
export const objectMap = (object, mapFn) => {
  return Object.keys(object).reduce(function(result, key) {
    result[key] = mapFn(object[key]);
    return result;
  }, {});
};

export const logger = params => {
  const loggingEnabled = true;
  if (loggingEnabled) {
    console.log(...params);
  }
};

export const logFormEvent = type => console.log.bind(console, type);
